if (!customElements.get('share-button')) {
  customElements.define(
    'share-button',
    class ShareButton extends HTMLElement {
      constructor() {
        super();

        this.elements = {
          shareButton: this.querySelector('button'),
          shareSummary: this.querySelector('summary'),
          closeButton: this.querySelector('.share-button__close'),
          successMessage: this.querySelector('[id^="ShareMessage"]'),
          urlInput: this.querySelector('input'),
          shareButton: this.querySelector('.share-button__message'),
          details: this.querySelector('details'),
        };

        if (navigator.share) {
          this.querySelector('.share-button__copy').addEventListener('click', this.copyToClipboard.bind(this));
          this.elements.closeButton.addEventListener('click', this.closePopUp.bind(this));
        }
      }

      copyToClipboard() {
        navigator.clipboard.writeText(this.elements.urlInput.value).then(() => {
          this.elements.successMessage.classList.remove('hidden');
          this.elements.successMessage.textContent = window.accessibilityStrings.shareSuccess;
          this.elements.closeButton.classList.remove('hidden');
          this.elements.closeButton.focus();
        });
      }

      closePopUp() {
        this.elements.details.removeAttribute('open');
        this.elements.shareButton.classList.add('hidden');
        this.elements.closeButton.classList.add('hidden');
      }
    },
  );
}
